module.exports = __webpack_public_path__ + "static/media/2020.6.27端午节未成年人看书活动.3428aeab.jpg";